// extracted by mini-css-extract-plugin
module.exports = {"featuredPosts":"NewsSidebar_featuredPosts__2ElVS","newsLink":"NewsSidebar_newsLink__20WFl"};